import { toast } from 'sonner';
import { downloadAuthedFile } from '@/lib/fileDownload';

/**
 * The QR sticker for a job card.
 *
 * The image comes from the backend rather than being drawn here, so the printed
 * sticker and the code the scanner expects are generated in one place. Three
 * screens offer the download and each had written its own copy of this — with
 * two different localStorage keys and one missing `/api`, so the supervisor
 * screen's button had never worked.
 */
export function downloadJobCardQr(jobCardId, label) {
  if (!jobCardId) return;
  downloadAuthedFile(`/jobcard/${jobCardId}/qr`, `QR_${label || jobCardId}.png`)
    .catch(() => toast.error('Could not download the QR code'));
}
